import { render, staticRenderFns } from "./ModelSubscription.vue?vue&type=template&id=3b3f29fb"
import script from "./ModelSubscription.vue?vue&type=script&lang=js"
export * from "./ModelSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports